import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  hiddenMenuItem: {
    display: "none",
  },
}));

export default useStyles;
